import { trigger, transition, style, animate } from '@angular/animations';

const ANIMATION_DURATION = 700;

export const fadeInOut = trigger('fadeInOut', [
  transition(':enter', [style({ opacity: 0 }), animate(`${ANIMATION_DURATION}ms ease-out`, style({ opacity: 1 }))]),
  transition(':leave', [animate(`${ANIMATION_DURATION}ms ease-in`, style({ opacity: 0 }))]),
]);

export const fadeInOnly = trigger('fadeInOnly', [
  transition(':enter', [style({ opacity: 0 }), animate(`${ANIMATION_DURATION}ms ease-out`, style({ opacity: 1 }))]),
]);
export const fadeInOnlyDelayed = trigger('fadeInOnlyDelayed', [
  transition(':enter', [style({ opacity: 0 }), animate(`${ANIMATION_DURATION}ms 500ms ease-out`, style({ opacity: 1 }))]),
]);

export const growWidth = trigger('growWidth', [
  transition('void => *', [style({ width: '0' }), animate('300ms ease-in', style({ width: '*' }))]),
]);
